// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-Agencies-styles___loaderWrapper--PmE2Q {
  position: relative;
}
.pages-Agencies-styles___tabs--HOpL4,
.pages-Agencies-styles___tab--KaZpA {
  text-transform: initial !important;
}
.pages-Agencies-styles___tabs--HOpL4 {
  border-bottom: 1px solid #c6c8cc;
  margin-bottom: 35px;
}
.pages-Agencies-styles___loyalityTabs--PSR5m {
  margin-top: 16px;
}
.pages-Agencies-styles___loyalityTabs--PSR5m .pages-Agencies-styles___tab--KaZpA {
    flex: 1;
    max-width: 20% !important;
  }
.pages-Agencies-styles___agencyNameContainer--LUvxX {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pages-Agencies-styles___agencyNameContainer--LUvxX h1 {
    margin-right: 32px;
  }
.pages-Agencies-styles___container--HzaTJ {
  display: flex;
}
.pages-Agencies-styles___container--HzaTJ .pages-Agencies-styles___content--lXyIZ {
    flex: 1;
    margin-right: 30px;
  }
.pages-Agencies-styles___container--HzaTJ .pages-Agencies-styles___sidebar--YVPkm {
    flex: 352px 0 1;
    min-width: 300px;
  }
.pages-Agencies-styles___inputContainer--yRYuA {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 12px;
}
.pages-Agencies-styles___inputContainer--yRYuA .pages-Agencies-styles___inputWrapper--l70HA {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }
.pages-Agencies-styles___paper--MYd9I {
  padding: 32px 32px 0;
  max-width: 736px;
  margin: 0 0 30px;
}
.pages-Agencies-styles___agencySetting--WZP8U {
  padding-bottom: 0;
}
.pages-Agencies-styles___agencySetting--WZP8U h2 {
    margin-bottom: 10px;
    font-weight: 600 !important;
  }
`, "",{"version":3,"sources":["webpack://./pages/Agencies/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;;EAEE,kCAAkC;AACpC;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AAEA;EACE,gBAAgB;AAMlB;AAJE;IACE,OAAO;IACP,yBAAyB;EAC3B;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AAKrB;AAHE;IACE,kBAAkB;EACpB;AAGF;EACE,aAAa;AAWf;AATE;IACE,OAAO;IACP,kBAAkB;EACpB;AAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AAGF;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AAMnB;AAJE;IACE,aAAa;IACb,gBAAgB;EAClB;AAGF;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,iBAAiB;AAMnB;AAJE;IACE,mBAAmB;IACnB,2BAA2B;EAC7B","sourcesContent":[".loaderWrapper {\n  position: relative;\n}\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-bottom: 35px;\n}\n\n.loyalityTabs {\n  margin-top: 16px;\n\n  .tab {\n    flex: 1;\n    max-width: 20% !important;\n  }\n}\n\n.agencyNameContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  h1 {\n    margin-right: 32px;\n  }\n}\n\n.container {\n  display: flex;\n\n  .content {\n    flex: 1;\n    margin-right: 30px;\n  }\n\n  .sidebar {\n    flex: 352px 0 1;\n    min-width: 300px;\n  }\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-top: 12px;\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n  }\n}\n\n.paper {\n  padding: 32px 32px 0;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.agencySetting {\n  padding-bottom: 0;\n\n  h2 {\n    margin-bottom: 10px;\n    font-weight: 600 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrapper": `pages-Agencies-styles___loaderWrapper--PmE2Q`,
	"tabs": `pages-Agencies-styles___tabs--HOpL4`,
	"tab": `pages-Agencies-styles___tab--KaZpA`,
	"loyalityTabs": `pages-Agencies-styles___loyalityTabs--PSR5m`,
	"agencyNameContainer": `pages-Agencies-styles___agencyNameContainer--LUvxX`,
	"container": `pages-Agencies-styles___container--HzaTJ`,
	"content": `pages-Agencies-styles___content--lXyIZ`,
	"sidebar": `pages-Agencies-styles___sidebar--YVPkm`,
	"inputContainer": `pages-Agencies-styles___inputContainer--yRYuA`,
	"inputWrapper": `pages-Agencies-styles___inputWrapper--l70HA`,
	"paper": `pages-Agencies-styles___paper--MYd9I`,
	"agencySetting": `pages-Agencies-styles___agencySetting--WZP8U`
};
module.exports = ___CSS_LOADER_EXPORT___;
